export const CUSTOM_SERIES = {
  AVERAGE: 'average',
  DRAW_SMA: 'drawSma',
  BUY_SELL: 'buySell',
} as const

export type CustomSeries = typeof CUSTOM_SERIES[keyof typeof CUSTOM_SERIES]
